<template>
  <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true" ref="pswp">
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>
      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <div class="pswp__counter"></div>
          <button class="pswp__button pswp__button--close" title="Закрыть (Esc)"></button>
          <button class="pswp__button pswp__button--share" title="Share"></button>
          <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
          <button class="pswp__button pswp__button--zoom" title="Приблизить/отдалить"></button>
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip"></div>
        </div>
        <button class="pswp__button pswp__button--arrow--left" title="Назад">
        </button>
        <button class="pswp__button pswp__button--arrow--right" title="Вперёд">
        </button>
        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhotoSwipe from 'photoswipe/dist/photoswipe';
// eslint-disable-next-line camelcase
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import { filter } from 'lodash';

const options = {
  index: 0,
  pinchToClose: false,
  closeOnScroll: false,
  history: false,
  showAnimationDuration: 0,
  hideAnimationDuration: 0,
  showHideOpacity: true,
  fullscreenEl: false,
  shareEl: false,
  preloaderEl: false,
};

export default {
  name: 'PhotoViewer',
  props: {
    containerId: String,
    multiple: Boolean,
  },
  data() {
    return {
      images: [],
      items: [],
      gallery: null,
    };
  },
  methods: {
    init() {
      this.getImages();

      if (this.multiple) {
        this.items = this.getItems();
      }
    },
    getImages() {
      this.images = this.container.querySelectorAll('img:not(.emoji)');
      this.images = filter([...this.images],
        (img) => img.naturalWidth < 1 || img.naturalWidth > 200);
      this.images.forEach((img, i) => {
        img.classList.add('pswp-preview');
        img.addEventListener('click', () => this.open(img, i));
      });
    },
    getItems() {
      return this.images.map((img) => ({
        src: img.src,
        w: img.naturalWidth,
        h: img.naturalHeight,
      }));
    },
    open(img, i) {
      if (!this.multiple) {
        this.items = [{
          src: img.src,
          w: img.naturalWidth,
          h: img.naturalHeight,
        }];
      }

      options.index = i;

      this.gallery = new PhotoSwipe(this.$el, PhotoSwipeUI_Default, this.items, options);

      if (this.multiple) {
        this.gallery.listen('imageLoadComplete', (index, item) => {
          const itemObj = item;
          itemObj.w = this.images[index].naturalWidth;
          itemObj.h = this.images[index].naturalHeight;
          this.gallery.updateSize(true);
        });
      }

      this.gallery.init();
    },
  },
  mounted() {
    this.container = document.getElementById(this.containerId);
    if (!this.container) {
      return;
    }
    setTimeout(this.init, 50);
  },
};
</script>

<style lang="scss" scoped>
  @import "~photoswipe/dist/photoswipe.css";
  @import "~photoswipe/dist/default-skin/default-skin.css";
</style>
